import { useRouter } from "vue-router";

/*
  Leave an edit view by going back in history, so the list the user came from
  keeps its page/search/filters (they live in the list's URL query).
*/
export function useGoBack() {
  const router = useRouter();

  // vue-router writes the previous location to history.state.back. If there is
  // none (edit URL opened directly: new tab / bookmark), use the fallback path.
  return (fallback) =>
    window.history.state?.back ? router.back() : router.replace(fallback);
}
